import React, { Component } from 'react';
import { Button, Popconfirm, Modal, Tabs, Icon, Popover, Input, message, Spin, Switch ,Radio, Tooltip } from 'antd';
import { Prompt } from 'react-router-dom';
import TableC from '../../basicElement/TableC';
import CloneVisit from "./components/CloneVisit";
import CutOff from "./components/CutOff";
import PreviewVisit from "./components/PreviewVisit";
import SetAgainst from "./components/SetAgainst";
import SetCount from "./components/SetCount";
import SortList from './components/SortList';
import Update from "./components/Update";
import VisitStage from "./components/VisitStage";
import PlanVisitParams from "./components/PlanVisitParams";
import ExportModal from "./components/ExportModal";
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';
import { ConfigDesc } from './constants';
import { getMatchOption } from '../../shared/selectFn';
import Text from '../../basicElement/Text';
import ConversionParams from './components/ConversionParams';

const { TabPane } = Tabs;
const RadioGroup = Radio.Group;


class VisitPeriodPlanHandle extends Component {
    constructor(props) {
        super(props);
        const { invState, invStatus, blindInvId, blindType } = sessionStorage;
        this.isConfig = invState == 3;
        this.isNewVisit = false;
        this.published = false;
        this.Audited = false;
        this.completed = invStatus == 'COMPLETED';
        this.isUnBlind = blindType === 'NOTBLIND';
        this.isBoundBlind = !!blindInvId;            // 非盲项目是否绑定盲态项目
        this.state = {
            loading: false,
            panes: [],
            data: [],
            activeKey: '',
            selectKey: '',
            planName: '',
            lineOfBusiness:'',
            invPlanStatus:'',
            isFilterProcess:1,
            isPublishConfirm:false,
            jumpOtherPage:false,
            approvalHandleShow:false,
            theReasonForRefusal:null,
            approvalStatus:null,
            currentPublishStatus:'',
            publishCheckUrl:null,
            investigationFileName: [],
            investigationFileId: [],
        };
    }

    componentDidMount() {
        this.queryPlan();
    }
  

    queryPlan = () => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryVisitGrouping,
            data: { publishStatus: 'ALL' },
            dataType: 'json',
            doneResult: res => {
                const { activeKey } = this.state;
                const { data, currentPublishStatus ,lineOfBusiness, canAudit, publishCheckUrl, investigationFileInfo } = res;
                let nextActiveKey;
                if (activeKey && (data || []).find(i => i.visitGroupingId == activeKey)) {
                    nextActiveKey = activeKey;
                } else {
                    const [{ visitGroupingId } = {}] = data || [];
                    nextActiveKey = visitGroupingId ? String(visitGroupingId) : undefined;
                }
                this.published = currentPublishStatus === 'PUBLISHED';
                this.Audited = (canAudit && currentPublishStatus === 'PENDING_APPROVAL');
                const list = investigationFileInfo ? [investigationFileInfo] : []
                const investigationFileName = this.findNodePath(list, 'fileName');
                const investigationFileId = this.findNodePath(list, 'fileManageId');
                this.setState({
                    loading: false,
                    panes: data || [],
                    activeKey: nextActiveKey,
                    lineOfBusiness,
                    currentPublishStatus,
                    publishCheckUrl,
                    investigationFileName,
                    investigationFileId,
                }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    // 递归查找节点路径
    findNodePath = (data, key, path = []) => {
        for (let node of data) {
            const currentPath = [...path, node[key]];
            if (!node.child) {
                return currentPath;
            }
            // 如果有子节点，递归查找
            if (node.child && node.child.length > 0) {
                const foundPath = this.findNodePath(node.child, key, currentPath);
                if (foundPath) {
                    return foundPath;
                }
            }
        }
        return null
    };

    deletePlan = (targetKey) => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.deleteVisitGrouping,
            data: { visitGroupingId: targetKey },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.queryPlan();
                });
            },
            errorResult: (() => {
                this.setState({ loading: false });
            })
        });
    }

    loadData = () => {
        const { activeKey } = this.state;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.visitTypeDataList,
            data: {
                visitGroupingId: activeKey,
                publishStatus: this.isConfig ? 'ALL' : '',
            },
            dataType: 'json',
            doneResult: res => {
                const { visitTypeList } = res.data || {};
                this.isNewVisit = (visitTypeList || []).length ? visitTypeList[0].count != undefined : true;
                this.setState({
                    loading: false,
                    data: visitTypeList || [],
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    toExport = () => {
        const { invId } = sessionStorage;
        const { activeKey } = this.state;
        ExportUtil.export({ investigationId: invId, visitGroupingId: activeKey }, null, API_URL.export.exportVisitType);
    }

    export = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryInvLineOfBusiness,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data } = res || {};
                if(data == '39' || data == '40'){ // 39 = ARO; 40 = 招募;  后台提供
                    this.toExport();
                }
                else{
                    const { invId } = sessionStorage;
                    const { activeKey, invPlanStatus } = this.state;
                    this.exportModalRef.show({ investigationId: invId, visitGroupingId: activeKey, invPlanStatus });
                }
            },
            errorResult: () => {
                //this.setState({ loading: false });
            }
        });
      
    }

    getInvPlanStatus = (paramms)=>{
        const { data: invPlanStatus, isFilterProcess } = paramms|| {};
        this.setState({
            invPlanStatus,
            isFilterProcess,
        })
    }

    preDelete = (visitTypeId, /* 检验位 */ confirm, confirmManHour) => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.deleteVisitType,
            data: {
                visitTypeId,
                confirm,
                confirmManHour,
            },
            dataType: 'json',
            doneResult: res => {
                const { confirmError, confirmManHourError } = res;
                this.setState({ loading: false });
                if (confirmError) {
                    this.confirmDelete(visitTypeId, confirmError, 'confirm');
                } else if (confirmManHourError) {
                    this.confirmDelete(visitTypeId, confirmManHourError, 'manHour');
                } else {
                    message.success('删除成功！');
                    this.loadData();
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    confirmDelete = (visitTypeId, message, type) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: <div style={{marginLeft: 42}}>{message}</div>,
            onOk: () => {
                if (type == 'confirm') {
                    this.preDelete(visitTypeId, 1, 0);
                } else if (type == 'manHour') {
                    this.preDelete(visitTypeId, 1, 1);
                }
            },
        });
    }
    
    prePublish = () => {
        const {currentPublishStatus} = this.state
        if(currentPublishStatus === 'PENDING_APPROVAL'){
            message.error('访视周期计划发布审批中，不可重复发布！');
        }else{
            Modal.confirm({
                iconType: 'question-circle',
                title: this.published ? '是否取消发布访视周期计划' : '是否确认发布已配置的访视周期计划',
                content: this.published ? '取消发布后，访视记录填写页不再显示访视周期计划部分（取消发布不会影响已填写的数据）' : '待领域leader/业务线负责人审批通过后会自动发布',
                onOk: this.publish,
            });
        }
        
    }

    publish = () => {
        const { invId } = sessionStorage;
        const { jumpOtherPage ,approvalStatus,theReasonForRefusal } = this.state;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.updateVisitTypePublishStatus,
            data: { 
                investigationId: invId,
                publishStatus: approvalStatus?approvalStatus:this.published ? 'UNPUBLISHED' : 'PUBLISHED',
                remark:theReasonForRefusal
            },
            dataType: 'json',
            doneResult: () => {
                message.success(`${approvalStatus?'审批':this.published ? '取消' : '发布'}成功`);
                this.setState({ loading: false,approvalHandleShow:false }, () => {
                    this.queryPlan();
                    if(jumpOtherPage)
                    {
                        window.location.reload();
                        this.cancelConfirm();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60
        }, {
            title: '访视阶段',
            dataIndex: 'stageValue',
            key: 'stageValue',
            fixed: 'left',
            width: 160,
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {},
                };
                if (row.rowSpan != null) {
                    obj.props.rowSpan = row.rowSpan;
                }
                return obj;
            }
        }, {
            title: '访视周期',
            dataIndex: 'periodValue',
            key: 'periodValue',
            width: 100,
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {},
                };
                if (row.periodRowSpan != null) {
                    obj.props.rowSpan = row.periodRowSpan;
                }
                return obj;
            }
        }, {
            title: '访视次数',
            dataIndex: 'visitTypeName',
            key: 'visitTypeName',
            width: 100,
        }];
        if (this.isBoundBlind) {
            columns.push({
                title: '关联对应盲态项目访视次数',
                dataIndex: 'relatedTypeName',
                key: 'relatedTypeName',
                width: 100,
            });
        }
        columns.push({
            title: '访视类型',
            dataIndex: 'visitingTypeShow',
            key: 'visitingTypeShow',
            width: 160,
        });
        if (sessionStorage.curRole !== 'CRC') {
            columns.push(
            {
                title:(
                    <span>
                        单访视工时
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'点击下方图标，可查看合同计划单访视工时折算系数'}>
                            <a 
                                onClick={() => this.conversionParamsRef.show()}
                            >
                                <Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" />
                            </a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'singleVisitHour',
                key: 'singleVisitHour',
                width: 120,
            })
        }
        columns.push({
            title: '次数',
            dataIndex: 'count',
            key: 'count',
            width: 80
        }, {
            title: '对照基准',
            dataIndex: 'referenceVisitTypeName',
            key: 'referenceVisitTypeName',
            width: 100,
        }, {
            title: '访视时间点',
            dataIndex: 'visitTypeWindowDay',
            key: 'visitTypeWindowDay',
            width: 100,
        }, {
            title: '访视窗口',
            dataIndex: 'visitTypeWindowInfo',
            key: 'visitTypeWindowInfo',
            width: 100,
        });
        if (this.isConfig) {
            const disabled = this.completed || !this.isNewVisit;
            columns.push({
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 200,
                render: (text, record) => {
                    const { visitTypeId } = record;
                    return ( 
                        <span>
                            <a disabled={disabled} onClick={() => this.update(record, 'edit')}>修改</a>
                            <span className="ant-divider"/>
                            <Popconfirm title='确定要删除吗?'
                                onConfirm={() => this.preDelete(visitTypeId, 0, 0)}
                                okText="确定"
                                cancelText="取消"
                            >
                                <a disabled={disabled}>删除</a>
                            </Popconfirm>
                            <span className="ant-divider"/>
                            <a disabled={disabled} onClick={() => this.setCount(record)}>设置次数</a>
                            <span className="ant-divider"/>
                            <a disabled={disabled} onClick={() => this.setAgainst(record)}>设置违背</a>
                        </span>
                    );
                },
            });
        }
        return columns;
    }

    handleTabChange = (activeKey) => {
        if (activeKey != 'plus-circle-o') {
            this.setState({ activeKey }, () => {
                this.loadData();
            });
        }
    }

    handleTabAction = (targetKey, action) => {
        if (action === 'add') {
            this.cloneRef.show();
        } else if (action === 'remove') {
            Modal.confirm({
                iconType: 'exclamation-circle',
                title: '确定要删除该访视方案吗?',
                onOk: () => {
                    this.deletePlan(targetKey);
                },
            });
        }
    }

    handleDbClick = ({ visitGroupingId, visitGroupingName }) => {
        this.setState({
            selectKey: visitGroupingId,
            planName: visitGroupingName,
        }, () => {
            document.getElementById(visitGroupingId).focus();
        });
    }

    handleChange = (e) => {
        this.setState({ planName: e.target.value });
    }

    handleBlur = () => {
        const { planName, selectKey } = this.state;
        if (!planName || !planName.trim()) {
            return message.warning('访视方案名称不能为空!');
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.modifyVisitGrouping,
            data: {
                visitGroupingId: selectKey,
                visitGroupingName: planName,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    selectKey: '',
                    planName: '',
                }, () => {
                    this.queryPlan();
                });
            }
        });
    }

    sort = () => {
        this.sortRef.show();
    }
    
    addStage = () => {
        this.stageRef.show();
    }

    planVisitParams = () => {
        this.planVisitParamsRef.show();
    }

    update = (record, type) => {
        this.updateRef.show(record, type);
    }

    setCount = record => {
        if (record.relatedId) {
            message.error('本访视与盲态项目已关联，不可单独设置次数！');
        } else {
            this.countRef.show(record);
        }
    }

    setAgainst = (record) => {
        this.againstRef.show(record);
    }

    cutOff = () => {
        this.cutOffRef.show();
    }

    preview = () => {
        this.previewRef.show();
    }

    getContent = ({ visitGroupingId }) => {
        const { data, activeKey } = this.state;
        if (visitGroupingId == activeKey) {
            const disabled = this.completed || !this.isNewVisit;
            return (
                <div>
                    {
                        this.isConfig &&
                        <div className="filter-bar tar">
                            <Button disabled={disabled} type="primary" onClick={this.addStage}>添加阶段/周期</Button>
                            <Button disabled={disabled} type="primary" onClick={() => this.update({}, 'add')}>添加访视</Button>
                            <Button disabled={disabled} type="primary" onClick={this.sort}>排序调整</Button>
                            {
                                !this.isNewVisit &&
                                <Button style={{position: 'absolute', right: 0, color: '#fff', background: '#f04134'}} onClick={this.cutOff}>访视次数割接调整</Button>
                            }
                        </div>
                    }
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        className="visitPeriodPlan"
                        rowKey='visitTypeId'
                    />
                </div>
            );
        } else {
            return null;
        }
    }

    toggle = (checked) => {
        const options = {
            method: 'POST',
            url: API_URL.plan.changeInvestigationFilterProcess,
            data: {
                isFilterProcess: checked ? 1 : 0,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                const isFilterProcess = checked ? 1 : 0;
                this.setState({ isFilterProcess });
            }
        };
        $.sendRequest(options);
    }

    // 跳转页面时，提示信息弹出框
    unAddShelf =(location)=> {
        const { currentPublishStatus } = this.state
        if( currentPublishStatus === 'UNPUBLISHED' ){
            //location 携带的路径
            const pathUrl = location.pathname + location.search;
            this.setState({
                redirectUrl:pathUrl,
                isPublishConfirm: true,
            });
            return false
        }
    }

    saveSessionStorage = () =>{
        const { curSession } = localStorage; 
        if(curSession)
        {
            const backSession = JSON.parse(curSession) || {};
            (Object.keys(backSession) || []).forEach(item=>
                {
                    sessionStorage[item] = backSession[item];
                }
            )
        }
       
    }

    noPublish =()=>{
        window.location.reload();
        this.cancelConfirm();
    }

    toPublish =()=>{
        this.saveSessionStorage();
        setTimeout(() => {
        this.setState({
            jumpOtherPage:true,
        },()=>{
            this.prePublish();
            location.href = `./#/executeMgr/visitPeriodPlan`; 
            this.cancelConfirm();
        })
    }, 10);
    }

    backToEdit =()=>{
        this.saveSessionStorage();
        setTimeout(() => {
            location.href = `./#/executeMgr/visitPeriodPlan`; 
            window.location.reload();
            this.cancelConfirm();
        }, 10);
       
    }

    cancelConfirm =()=>{
        localStorage.removeItem('curSession');
        this.setState({
            isPublishConfirm:false
        })
    }

    audit =()=>{
        const {approvalStatus,theReasonForRefusal} = this.state
        if(!approvalStatus){
            message.error('请选择审核结论！');
            return
        }else if(approvalStatus ==='DISAGREE_APPROVAL' && !theReasonForRefusal){
            message.error('请填写审核不通过原因！');
            return
        }
        this.publish()
    }

    openNewPage = () => {
        const { investigationFileId } = this.state;
        // 要传递给新页面的数据
        const dataToStore = { 
            invState: 1, 
            investigationSiteName: '中心汇总', 
            investigationFileId 
        };
        
        // 编码为 URL 参数（使用 encodeURIComponent 避免特殊字符问题）
        const queryParams = new URLSearchParams();
        queryParams.append('data', JSON.stringify(dataToStore));
        
        // 打开新页面并传递参数
        window.open(`./#/fileManagement/projectFile?${queryParams.toString()}`, '_blank');
    };

    render() {
        const { loading, panes, activeKey, selectKey, planName,lineOfBusiness, isFilterProcess, isPublishConfirm,approvalHandleShow,approvalStatus,theReasonForRefusal, publishCheckUrl, investigationFileName } = this.state;
        const { invState, blindType  } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';
        const { relatedId } = getMatchOption(panes, 'visitGroupingId', activeKey);
        const editable = this.isConfig && !this.isBoundBlind;
        return (
            <div style={{ backgroundColor:'#fff' , padding:'20px'}}>
                <div className="main plan-visitType">
                    <div className="breadcrumb-bar tac">
                        {
                            this.isConfig &&
                            <Popover placement="right" overlayClassName="propercent-pop" content={ConfigDesc}>
                                <div style={{float: 'left'}}>
                                    <Icon type="info-circle" style={{color: '#5750c9', marginRight: 4}} />
                                    <a>配置说明</a>
                                </div>
                            </Popover>
                        }
                        <h2 className="title">访视周期计划</h2>
                    </div>
                    <div style={{margin: '10px 0', textAlign: 'right'}}>
                        {
                            (this.isConfig && !isUnBlind) &&  <span style={{marginRight:'10px'}}><Switch checkedChildren="开" unCheckedChildren="关" onChange={this.toggle} checked={isFilterProcess == 1}/> 筛选流程</span>
                        }
                        {lineOfBusiness !== null && lineOfBusiness !== '39' && lineOfBusiness !== '40' && this.isConfig && <Button type="primary" onClick={this.planVisitParams}>计划访视参数设置</Button>}
                        <Button type="primary" onClick={this.export} style={{ marginLeft: 8 }}>导出</Button>
                        { this.isConfig && !this.isUnBlind && <Button type="primary" style={{ marginLeft: 8 }} onClick={this.preview}>预览</Button> }
                        { this.isConfig && <Button type="primary" style={{ marginLeft: 8 }} onClick={this.Audited?()=>{this.setState({approvalHandleShow :true})}:this.prePublish}>{this.Audited? '发布审批' :this.published ? '取消发布' : '发布' }</Button> }
                    </div>
                    <Spin spinning={loading}>
                        <Tabs
                            hideAdd
                            activeKey={activeKey}
                            type="editable-card"
                            onEdit={this.handleTabAction}
                            onChange={this.handleTabChange}
                        >
                            {
                                panes.map((pane, index, array) => {
                                    const { visitGroupingId, visitGroupingName } = pane;
                                    const closable = editable && (array.length > 1);
                                    let title = visitGroupingName;
                                    if (editable) {
                                        title = <span onDoubleClick={() => this.handleDbClick(pane)}>{visitGroupingName}</span>;
                                    }
                                    if (selectKey === visitGroupingId) {
                                        title = <Input value={planName} id={visitGroupingId} style={{ width: 100 }} onChange={this.handleChange} onBlur={this.handleBlur} />;
                                    }
                                    return (
                                        <TabPane
                                            key={visitGroupingId}
                                            tab={title}
                                            closable={closable}
                                        >
                                            {this.getContent(pane)}
                                        </TabPane>
                                    );
                                })
                            }
                            {
                                editable ?
                                    <TabPane
                                        closable={false}
                                        key="plus-circle-o"
                                        tab={<Icon type="plus-circle-o" onClick={() => this.handleTabAction('', 'add')} />}
                                    />
                                :
                                    []
                            }
                        </Tabs>
                    </Spin>
                    <SetCount ref={el => this.countRef = el } loadData={this.loadData} />
                    <VisitStage ref={el => this.stageRef = el } loadData={this.loadData} visitGroupingId={activeKey} />
                    <PlanVisitParams ref={el => this.planVisitParamsRef = el } loadData={this.loadData} 
                        visitGroupingId={activeKey}
                        panes={panes} handleDbClick={this.handleDbClick}
                        getInvPlanStatus = {this.getInvPlanStatus}
                    />
                    <SetAgainst ref={el => this.againstRef = el } loadData={this.loadData} visitGroupingId={activeKey} />
                    <CutOff ref={el => this.cutOffRef = el } loadData={this.loadData} visitGroupingId={activeKey} />
                    <SortList ref={el => this.sortRef = el } loadData={this.loadData} visitGroupingId={activeKey} />
                    <CloneVisit ref={el => this.cloneRef = el} panes={panes} loadData={this.queryPlan} />
                    <PreviewVisit ref={el => this.previewRef = el}  isFilterProcess= {isFilterProcess}/>
                    <Update
                        ref={el => this.updateRef = el }
                        loadData={this.loadData}
                        visitGroupingId={activeKey}
                        refGroupId={relatedId}
                        isBoundBlind={this.isBoundBlind}
                    />
                    <ExportModal ref={el => this.exportModalRef = el}/>
                </div>
                {/* 跳转页面时的确认框 */}
                <Modal
                    //title=""
                    visible={isPublishConfirm}
                    onCancel={this.cancelConfirm}
                    className="create-modal sort-modal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="500px"
                    footer={[
                        <Button type="primary" onClick={this.backToEdit}>
                            返回修改
                        </Button>,
                        <Button type="primary" onClick={this.noPublish}>
                            否，暂不发布
                        </Button>,
                        <Button type="primary" onClick={this.toPublish}>
                            是，立刻发布
                        </Button>
                    ]}
                >
                    <div style={{ margin:'25px', fontSize:'16px', fontWeight:'bloder'}}>
                        <Icon type="question-circle" style={{ fontSize:24, color:'#ffbf00'}} />
                        <span style={{ marginLeft:10 }}>您还没有发布访视周期计划，是否立刻发布？</span></div>
                </Modal>
                
                <Prompt
                    when={!this.published && this.isConfig } 
                    message={this.unAddShelf.bind(this)}
                />
                <ConversionParams ref={el => this.conversionParamsRef = el}/>
                {/* 跳转页面时的确认框 -- 结束*/}

                <Modal
                    title='发布审批'
                    visible={approvalHandleShow}
                    className="creat-modal EditPersonModal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="400px"
                    closable={false}
                    footer={<div style={{textAlign:"center"}}>
                        <Button style={{margin:'0 5px'}} onClick={()=>{this.setState({approvalHandleShow:false})}}>取消</Button>
                        <Button style={{margin:'0 5px',backgroundColor:'#1890ff'}} onClick={this.audit} type="primary">确定</Button>
                    </div>}
                >   
                    <div>
                        <div style={{fontSize:'14px', fontWeight: '700'}}>PM访视周期计划配置内容确认</div>
                        {/* <div>设计方案超链接：<span style={{ width:'270px', display:'inline-block',wordBreak:'break-word',verticalAlign:'top',whiteSpace:'pre-wrap'}}>{publishCheckUrl}</span></div> */}
                        <p>
                            设计方案文件路径：
                            <span 
                                style={{ 
                                    width: '270px', 
                                    display: 'inline-block',
                                    wordBreak: 'break-word', 
                                    verticalAlign: 'top', 
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                {(investigationFileName || []).join('-')}
                                <a 
                                    style={{ marginLeft: 8 }}
                                    onClick={this.openNewPage}
                                >
                                    跳转
                                </a>
                            </span> 
                        </p>
                        <div >
                            <label className="ui-label visit-lablel" style={{width:'200px', textAlign:'right'}}><Text asterisk={true}>审核结论:</Text></label>
                            <RadioGroup onChange={(e)=>{ this.setState({approvalStatus:e.target.value})}} value={approvalStatus} >
                                <Radio style={{marginLeft:'20px'}} value={'AGREE_APPROVAL'}>审批通过</Radio>
                                <Radio style={{margin:'10px'}} value={'DISAGREE_APPROVAL'}>审批不通过</Radio>
                            </RadioGroup>
                        </div>
                        {
                            (approvalStatus == 'DISAGREE_APPROVAL')&&
                            <div style={{marginTop:'5px'}}>
                            <label className="ui-label visit-lablel" style={{width:'200px', textAlign:'right'}}><Text asterisk={true}>审核不通过原因:</Text></label>
                            <Input
                                placeholder="请输入不通过原因"
                                value={theReasonForRefusal}
                                onChange={e=>{this.setState({theReasonForRefusal:e.target.value})}}
                                style={{width:'200px',marginLeft:'20px'}}
                            />
                        </div>
                        }
                        
                    </div>
                </Modal>
            </div>
        );
    }
}

export default VisitPeriodPlanHandle;



// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/VisitPeriodPlanHandle.js